import { useScorm } from '../../../../lib/context/ScormContext';
import styles from './CourseCard.module.scss';
import Loader from '../../../common/Loader/Loader';
import { Role, useRole } from '../../../../lib/context/SessionContext';
import { courseCardIds } from '../../../../lib/tests/testIds';
import ScormRemoveItemButton from './ScormRemoveItemButton';
import ScormAddItemButton from './ScormAddItemButton';
import { Api } from '../../../../lib/types/apiSpec';

type TrainingCardScormActionsProps = {
  id: string;
  type: Api.TrainingType;
  name: string;
};

const TrainingCardScormActions = ({ id, type, name }: TrainingCardScormActionsProps) => {
  const { addItem, removeItem, downloadsList, actionsState } = useScorm();

  const role = useRole();

  const inDownloadList = downloadsList?.data?.find(item => item.trainingId === id);

  const handleDelete = () => {
    const downloadsItem = downloadsList?.data?.find(item => item.trainingId === id);

    if (!downloadsItem) {
      return;
    }

    removeItem({ id: downloadsItem.id, trainingName: downloadsItem.name, trainingType: downloadsItem.type });
  };

  if (!downloadsList?.data || role !== Role.LEARNER_MANAGER) {
    return null;
  }

  const buttonCommonProps = {
    'data-testid': courseCardIds.scormActions,
    className: styles.scormAction,
  };

  if (actionsState[id]) {
    return <Loader containerProps={{ className: styles.scormActionLoader }} />;
  }

  if (inDownloadList) {
    return <ScormRemoveItemButton {...buttonCommonProps} onClick={handleDelete} />;
  }

  return (
    <ScormAddItemButton
      {...buttonCommonProps}
      onClick={() => addItem({ id, trainingName: name, trainingType: type })}
    />
  );
};

export default TrainingCardScormActions;
